import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';
import type SeenUserEngagementElement from 'lumen/models/seen-user-engagement-element';
import type { UserEngagementElementId } from 'lumen/models/seen-user-engagement-element';
import ApplicationSerializer from 'lumen/serializers/application';

interface SeenUserEngagementElementHash {
  element_id: UserEngagementElementId;
  id: UserEngagementElementId;
}

export default class SeenUserEngagementElementSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'data') {
      return 'seen-user-engagement-element';
    }

    return key;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(typeClass: ModelSchema, hash: SeenUserEngagementElementHash) {
    hash.element_id = hash.id;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(snapshot: Snapshot) {
    return {
      id: snapshot.id,
    };
  }

  /*
      This method is used to remove the parent key from the payload, so that the API accepts the payload.
      By default, the payload for saving a record would be:
        {
          "seenUserEngagementElement": {
            ...payload
          }
        }
      Instead, we want the payload to be:
        {
          data: {
            payload
          }
        }
    */

  serializeIntoHash(
    hash: SeenUserEngagementElement,
    _ModelClass: unknown,
    snapshot: Snapshot,
    options: { excludeUnchangedAttributes: boolean },
  ): void {
    // @ts-expect-error: Expected 1 arguments, but got 2.
    const serializedData = this.serialize(snapshot, options);
    Object.assign(hash, {
      data: [serializedData],
    });
  }
}
